import FontAwesome from 'react-fontawesome';
import {calcTime, convertMoney} from '../../../helpers';
import './MovieInfoBar.css';


function MovieInfoBar (props) {
  const{time, budget,revenue} = props;
    return (
      <div className="rmdb-movieinfobar">
        <div className="rmdb-movieinfobar-content">
          <div className="rmdb-movieinfobar-content-col">
            <FontAwesome
              className="fa-time"
              name="clock-o"
              size="2x"
            ></FontAwesome>
            <span className="rmdb-movieinfobar-info">
              Running Time: {calcTime(time)}
            </span>
          </div>
          <div className="rmdb-movieinfobar-content-col">
            <FontAwesome
              className="fa-budget"
              name="money"
              size="2x"
            ></FontAwesome>
            <span className="rmdb-movieinfobar-info">
              Budget: {convertMoney(budget)}
            </span>
          </div>
          <div className="rmdb-movieinfobar-content-col">
            <FontAwesome
              className="fa-revenue"
              name="ticket"
              size="2x"
            ></FontAwesome>
            <span className="rmdb-movieinfobar-info">
              Revenue: {convertMoney(revenue)}
            </span>
          </div>
        </div>
      </div>
    );
}

export default MovieInfoBar;